import { useDealItemPicker } from './DealItemPicker';
import { Money } from 'components/Money';
import { Table } from 'components/table/Table';
import { Text } from 'components/Text';
import { Fragment, useState } from 'libs/react';
import { React } from 'libs/react';
import { Icon } from 'components/Icon';
import { calculatePriceCurrency } from 'helpers/Pricing';
import { FormInput } from 'components/form/FormInput';
import { FormIconCheckBox } from 'components/form/FormIconCheckBox';
import { ButtonGroup } from 'components/ButtonGroup';
import './DealItemPickerPackageTable.scss';
/**
 * @component DealItemPickerPackageTable
 * @since 1.0.0
 */
export function DealItemPickerPackageTable(props) {
    let { values } = props;
    const { packages, appendPackage, removePackage, appendOption, removeOption, deal, quantityType, quantity, alternativeTo, hideSku } = useDealItemPicker();
    let selectedIds = packages
        .filter((p) => p.quantity > 0)
        .map((pack) => pack.package.id);
    const [quantityAlert, setQuantityAlert] = useState(false);
    const [currentSelections, setCurrentSelections] = useState([]);
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(checked, value, proposed) {
        if (checked && selectedIds.includes(value.id) && !isProposed(value)) {
            return;
        }
        if (checked) {
            appendPackage(value, proposed, quantity);
            selectedIds.push(value.id);
        }
        else {
            removePackage(value);
            selectedIds = selectedIds.filter((id) => id !== value.id);
        }
        setRequiredOptions(value, checked);
    }
    /**
     * @function isProposed
     * @since 1.0.0
     * @hidden
     */
    function isProposed(item) {
        const pack = packages.find((entry) => entry.package.id == item.id);
        if (pack == null) {
            return false;
        }
        return pack.proposed;
    }
    /**
     * @function onTypeChange
     * @since 1.0.0
     * @hidden
     */
    function onTypeChange(item, proposed) {
        const isSelected = packages.find((pack) => pack.package.id === item.id);
        if (isSelected) {
            removePackage(item);
            appendPackage(item, proposed, isSelected.quantity);
        }
        if (proposed) {
            onChange(true, item, true);
        }
        else {
            onChange(true, item, false);
        }
    }
    /**
     * @function getQuantity
     * @since 1.0.0
     * @hidden
     */
    function getQuantity(item) {
        const pack = packages.find((entry) => entry.package.id == item.id);
        if (pack == null) {
            return 0;
        }
        return pack.quantity;
    }
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    function onQuantityChange(item, qty) {
        //if (parseInt(qty) !== getQuantity(item)) {
        setQuantityAlert(true); // TODO : We no longer have this state for now
        //}
    }
    /**
     * @function onQuantityBlur
     * @since 1.0.0
     * @hidden
     **/
    function onQuantityBlur(item, qty) {
        /**
         * @function execute
         * @hidden
         * @since 1.0.0
         */
        function execute(makeChange) {
            const isSelected = packages.find((pack) => pack.package.id === item.id);
            if (isSelected) {
                removePackage(item);
                appendPackage(item, isSelected.proposed, makeChange ? parseInt(qty) : quantity);
            }
            else {
                appendPackage(item, false, makeChange ? parseInt(qty) : quantity);
            }
        }
        if (quantityAlert) {
            /*modal.present({
              style: 'dialog',
              title: t('Update quantity'),
              picto: 'edit',
              modal: (
                <Confirm
                  title={`${t(
                    'You are about to change the quantity that is different from the product quantity. Are you sure you want to continue?'
                  )}`}
                  infos={t(
                    'Selecting "Yes" will update the quantity of the package. Selecting "No" will cancel the update.'
                  )}
                  acceptText={t('Yes')}
                  refuseText={t('No')}
                  onAccept={() => {
                    execute(true);
                  }}
                  onRefuse={() => {
                    execute(false);
                  }}
                />
              )
            });
            */
            execute(true);
        }
    }
    /**
     * @function setRequiredOptions
     * @since 1.0.0
     * @hidden
     */
    function setRequiredOptions(data, checked) {
        var _a;
        const requiredOptions = (_a = data === null || data === void 0 ? void 0 : data.saleItems) === null || _a === void 0 ? void 0 : _a.filter((option) => option.required);
        if (requiredOptions) {
            requiredOptions.forEach((option) => {
                var _a;
                if (checked) {
                    appendOption(option.item, (_a = option.item.price) !== null && _a !== void 0 ? _a : 0, true, false, true, 1);
                }
                else {
                    removeOption(option.item);
                }
            });
        }
    }
    /**
     * @function onAlternativeSelect
     * @since 1.0.0
     * @hidden
     */
    function onAlternativeSelect(value, check) {
        var _a, _b;
        if (check) {
            const alternativeQuantity = (_b = (_a = packages.find((pack) => pack.package.id === alternativeTo)) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : quantity;
            appendPackage(value.package, true, alternativeQuantity, alternativeTo);
            setCurrentSelections([...currentSelections, value.package.id]);
        }
        else {
            removePackage(value.package);
            setCurrentSelections(currentSelections.filter((id) => id !== value.package.id));
        }
    }
    const onColumnClick = (value) => onChange(!selectedIds.includes(value.id), value, false);
    const columns = [];
    columns.push({
        column: 'icon',
        type: 'image',
        header: '',
        footer: '',
        onClick: onColumnClick,
        render: (value) => {
            var _a;
            return (React.createElement(Fragment, null,
                React.createElement(Icon, { className: "table-row-image", value: (_a = value.package.icon) !== null && _a !== void 0 ? _a : '' })));
        }
    });
    if (!hideSku) {
        columns.push({
            column: 'sku',
            header: t('SKU'),
            footer: t('SKU'),
            onClick: onColumnClick,
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { className: "table-row-value", value: value.package.sku })));
            }
        });
    }
    columns.push({
        column: 'title',
        header: t('Name'),
        footer: t('Name'),
        onClick: onColumnClick,
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Text, { className: "table-row-value", value: value.package.title })));
        }
    });
    columns.push({
        column: 'infos',
        header: t('Description'),
        footer: t('Description'),
        onClick: onColumnClick,
        render: (value) => {
            var _a;
            return (React.createElement(Fragment, null,
                React.createElement("div", { className: "table-row-value", dangerouslySetInnerHTML: { __html: (_a = value.package.infos) !== null && _a !== void 0 ? _a : '' } })));
        }
    });
    if (!alternativeTo &&
        (quantityType === 'GRANULAR' || quantityType === 'ITEM_CONFIGURATION')) {
        columns.push({
            column: 'quantity',
            header: t('Quantity'),
            footer: t('Quantity'),
            onClick: onColumnClick,
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement("div", { className: "table-row-status", onClick: (e) => {
                            e.stopPropagation();
                        } },
                        React.createElement(FormInput, { name: "quantity", type: "number", value: getQuantity(value.package).toString(), onFocus: () => onChange(true, value.package, false), onChange: (v) => {
                                onQuantityChange(value.package, v);
                            }, onBlur: (v) => {
                                onQuantityBlur(value.package, v);
                            }, size: "small" }))));
            }
        });
    }
    columns.push({
        column: 'price',
        header: t('Price'),
        footer: t('Price'),
        onClick: onColumnClick,
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Money, { className: "table-row-value", value: calculatePriceCurrency(value.package.price, deal === null || deal === void 0 ? void 0 : deal.currency) })));
        }
    });
    if (!alternativeTo) {
        columns.push({
            column: 'type',
            header: t('Actions'),
            infos: t('Suggest or select'),
            footer: t('Actions'),
            align: 'center',
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(ButtonGroup, null,
                        React.createElement(FormIconCheckBox, { checked: isProposed(value.package), checkedColor: "primary", checkedIcon: "fal heart-circle-check", uncheckedIcon: "fal heart", onChange: (check) => {
                                onTypeChange(value.package, check);
                            } }),
                        React.createElement(FormIconCheckBox, { checked: selectedIds.includes(value.package.id) &&
                                !isProposed(value.package), checkedColor: "secondary", checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: (check) => {
                                onChange(check, value.package, false);
                            } }))));
            }
        });
    }
    else {
        columns.push({
            column: 'action',
            type: 'actions',
            header: '',
            footer: '',
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(FormIconCheckBox, { className: "table-row-image", checked: currentSelections.includes(value.package.id), checkedColor: "secondary", checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: (check) => {
                            onAlternativeSelect(value, check);
                        }, disabled: selectedIds.includes(value.package.id) &&
                            !currentSelections.includes(value.package.id) })));
            }
        });
    }
    const schema = {};
    columns.forEach((column, index) => {
        schema['c' + (index + 1)] = column;
    });
    if (values == null) {
        values = [];
    }
    return (React.createElement(Table, { className: "deal-item-picker-package-table", schema: schema, values: values, primaryColumn: "c3" }));
}
